import type { SchemaUploadedDocument } from 'cpool-schemas';
import type { ValueOf } from 'cpool-utils';

export const UPLOAD_ITEM_STATUS = {
    SUCCESS: 'success',
    UPLOADING: 'uploading',
} as const;

export type UploadItemStatus = ValueOf<typeof UPLOAD_ITEM_STATUS>;

/** A document that has been recorded server-side; the `key` lets the modal delete it again. */
export type UploadedDocument = SchemaUploadedDocument;

export type UploadingItem = {
    /** Stable client id — the file name is not unique enough across a session. */
    id: string;
    file: File;
    status: typeof UPLOAD_ITEM_STATUS.UPLOADING;
    /** Whole-number percentage. */
    progress: number;
};

export type UploadedItem = {
    id: string;
    file: File;
    status: typeof UPLOAD_ITEM_STATUS.SUCCESS;
    /** Carries the server key for deletion. */
    uploaded: UploadedDocument;
    removing: boolean;
};

export type UploadItem = UploadingItem | UploadedItem;

// Resolves with the server document, throws on failure
export type UploadFileHandler = (
    file: File,
    handlers: { onProgress: (percent: number) => void; signal: AbortSignal },
) => Promise<UploadedDocument>;

/** Deletes a previously uploaded document (the trash action on a completed row). */
export type RemoveUploadedHandler = (document: UploadedDocument) => Promise<void>;
